const setPets = (state, pets) => (state.pets = pets);

const setPetsWithoutPag = (state, pet_without_pag) =>
  (state.pet_without_pag = pet_without_pag);

let mutations = {
  setPets,
  setPetsWithoutPag
};

export default mutations;
